export default __webpack_public_path__ + "static/media/plant3.7f864b4b.PNG";